// extracted by mini-css-extract-plugin
export default {"content":"Content_content__4kHb5","box":"Content_box__Mujkk"};